import { All } from '../All'
import { Book } from '../Book'
import { Bookstore } from '../Bookstore'
import { Brush as Workshop } from '../Brush'
import { Card } from '../Card'
import { Cinema } from '../Cinema'
import { Disk } from '../Disk'
import { FineArts } from '../FineArts'
import { LiveEvent } from '../LiveEvent'
import { Micro as Conference } from '../Micro'
import { Microphone } from '../Microphone'
import { Museum } from '../Museum'
import { Music } from '../Music'
import { Numeric } from '../Numeric'
import { Palette } from '../Palette'
import { Piano as Instrument } from '../Piano'
import { Press } from '../Press'
import { Show } from '../Show'
import { Streaming } from '../Streaming'
import { Thing } from '../Thing'
import { VideoGame } from '../VideoGame'

export const categoriesIcons = {
  All,
  Book,
  Bookstore,
  Card,
  Cinema,
  Conference,
  Disk,
  FineArts,
  Instrument,
  LiveEvent,
  Microphone,
  Museum,
  Music,
  Numeric,
  Palette,
  Press,
  Show,
  Streaming,
  Thing,
  VideoGame,
  Workshop,
}
